<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center
            >Freight Invoice For Billing - Sea Export Test</b-navbar-brand
          >
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                style="font-size: 0.675rem; margin-left: 5px"
                @click="
                  proceedAssignmentProforma(
                    ffInvoiceModal.allModuleId,
                    0,
                    ffInvoiceModal.jobNo
                  )
                "
                size="sm"
                class="ml-1"
                variant="outline-info"
                >Proceed To Proforma</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <banner-component
          :allModuleIdBanner="
            this.ffInvoiceModal.allModuleId ? this.ffInvoiceModal.allModuleId : ''
          "
          :jobSeriesBanner="this.ffInvoiceModal.jobNo ? this.ffInvoiceModal.jobNo : ''"
          :bannerClientName="
            this.ffInvoiceModal.clientName ? this.ffInvoiceModal.clientName : ''
          "
          iconId="fa fa-ship"
          :trackingId="trackingId != '' ? trackingId : ''"
        />

        <b-card class="formCard">
          <b-card-text>
            <div>
              <h4
                class="mt-3 error"
                v-if="sentForApproval == '1' && chnageApprovalStatus != '1'"
              >
                Invoice Sent For Approval
              </h4>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Job No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.jobNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Client Name</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.clientName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="containerTypeId">Invoice Status</label>
                  <model-list-select
                    :list="invoiceStatusList"
                    v-model="ffInvoiceModal.invoiceStatus"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Status"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <!-- 
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="clientRegistrationNo"
                      name="clientRegistrationNo"
                      v-model="ffInvoiceModal.adress"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>-->
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Place Of Receipt</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.POR"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Load Port</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.LP"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Port Of Discharge</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.POD"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Final Place of Delivery</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.FPOD"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="50" v-if="this.newContainerFlow == '0'">
                  <md-layout md-flex="100">
                    <label>Shipping Bill No/ Date (MM/DD/YY)</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.BOE"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5" v-if="this.newContainerFlow == '0'"></md-layout>
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>BL No</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.blNo"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label>MBL Release Date</label><br />
                  <md-layout md-flex="100">
                    <date-picker
                      :style="{ width: '500px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="mbl_release_date"
                      id="mbl_release_date"
                      class="mt-2"
                      v-model="ffInvoiceModal.mbl_release_date"
                    ></date-picker>
                    <span class="error" v-if="ffInvoiceModal.mbl_release_dateError">
                      {{ ffInvoiceModal.mbl_release_dateError }}
                    </span>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="this.newContainerFlow == '0'">
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice No.</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientRegistrationNo"
                      name="clientRegistrationNo"
                      v-model="ffInvoiceModal.shipperInvNo"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice Date (MM/DD/YY)</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientRegistrationNo"
                      name="clientRegistrationNo"
                      v-model="ffInvoiceModal.shipperInvDate"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Vessel/Voy</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.vessel"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Weight (KGS)</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.weight"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Shipping Line Name</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.shippingLine"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>

              <table id="ffContainer" class="table table-bordered mt-3">
                <tbody>
                  <tr>
                    <th>Sr No.</th>
                    <th>Container No.</th>
                    <th>Container Type</th>
                    <th>Shipper Inv & Date</th>
                    <th>Shipping Bill & Date</th>
                    <th>Gross Wgt.</th>
                    <th>BL Number</th>
                  </tr>
                  <tr v-for="(item, index) in containerTypeDetailFactory" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.fclConcontainerNo }}</td>

                    <td>{{ item.containerType }}</td>
                    <td>
                      {{ item.shipperInvoiceNo }} |
                      {{ item.shipperInvoiceDate }}
                    </td>
                    <td>{{ item.shippingBillNo }} | {{ item.SBDate }}</td>
                    <td>{{ item.conGrossWeight }} {{ item.weightUnit }}</td>
                    <td>{{ item.bl }}</td>
                  </tr>
                </tbody>
              </table>
              <Profit-Loss
                v-if="ffInvoiceModal.allModuleId"
                :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                :PMS_jb_series="ffInvoiceModal.jobNo"
                :PMS_fk_client_id="ffInvoiceModal.clientName"
                :PLAccordianStatus="false"
                :PLAccordianButton="true"
              />
              <Assignment-Timeline
                :TMAccordianStatus="false"
                :TMAccordianButton="true"
                :allModuleId="Number(ffInvoiceModal.allModuleId)"
              />
              <Payment-Summary
                v-if="ffInvoiceModal.allModuleId"
                :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                :PMS_jb_series="ffInvoiceModal.jobNo"
                :PMS_fk_client_id="ffInvoiceModal.clientName"
              />
              <!-- Other Expenses -->
              <!-- <div class="gutr">
                <div class="box-body gutr">
                  <h5>
                    <b-badge variant="info">Expense Details</b-badge>
                  </h5>
                  <table
                    id="otherExpense"
                    class="table table-bordered table-sm gutr"
                  >
                    <tbody>
                      <tr>
                        <th>Expense</th>
                        <th>Amount</th>
                        <th>Remark</th>
                        <th>Added on</th>
                      </tr>
                      <tr
                        v-for="(item, index) in otherExpenseData"
                        :key="index"
                      >
                        <td>
                          {{ item.ledger }}
                        </td>
                        <td>{{ item.amount }}</td>
                        <td>{{ item.remark }}</td>
                        <td>{{ item.loginTime }}</td>
                      </tr>
                      <tr v-if="otherExpenseData.length <= 0">
                        <td colspan="4" style="text-align: center; color: red">
                          <b>NO EXPENSE ADDED</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>-->
              <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label>Container Details</label>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <b-form-input :formatter="capitalizeAll"
                    disabled
                    class="gutr"
                    v-for="(item, index) in ffInvoiceModal.containerDetails"
                    :key="index"
                    id="clientRegistrationNo"
                    name="clientRegistrationNo"
                    :value="item"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <b-form-input :formatter="capitalizeAll"
                    disabled
                    class="gutr"
                    v-for="(item1, index) in ffInvoiceModal.multipleContainerType"
                    :key="index"
                    id="clientRegistrationNo"
                    name="clientRegistrationNo"
                    :value="item1"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
            
              </md-layout>-->

              <!-- <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Port Charges Details</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="PortAdditionalCharges"
                      name="PortAdditionalCharges"
                      v-model="ffInvoiceModal.PortAdditionalCharges"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>-->

              <div class="mt-3">
                <h5>
                  <b-badge>Charges</b-badge>
                </h5>
              </div>
              <div class="mt-3">
                <h5>
                  <span class="error mt-4">
                    Note : Approval will be required when Selling Rate is less than
                    Quotation Rate.!
                  </span>
                </h5>
                <br />
                <span class="error mt-1">* marked heads are mandatory..!</span>
              </div>

              <table id="quotationDetail" class="table mt-3 table-light table-bordered">
                <tbody>
                  <tr>
                    <th>
                      <b-button
                        variant="outline-info"
                        size="sm"
                        @click="addQuotationFields"
                      >
                        <!-- @click="addQuotationFields" -->
                        <md-icon>add</md-icon>
                      </b-button>
                    </th>

                    <th>Particulars*</th>
                    <th style="width: 200px">Container Type*</th>
                    <th style="width: 50px">Quantity*</th>
                    <!-- <th>Currency*</th> -->
                    <th style="width: 125px">Quotation Rate</th>
                    <th style="width: 125px">Selling Rate*</th>
                    <th style="width: 125px">Currency*/Exch Rate*/Unit*</th>
                    <th style="width: 125px">Invoice Amount(Without Taxes)*</th>

                    <th style="width: 150px">Remarks</th>
                  </tr>
                  <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                    <td>
                      <b-button
                        v-if="ffTallyInvoiceData.length > 1"
                        size="sm"
                        variant="outline-info"
                        @click="removeCol(index)"
                      >
                        <i class="fa fa-times"></i>
                      </b-button>
                    </td>
                    <!-- <td>{{index+1}}</td> -->
                    <td>
                      <model-list-select
                        :isDisabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        :list="ledgerData"
                        v-model="item.ffType"
                        option-value="ledger"
                        option-text="ledger"
                        placeholder="Select Type"
                      ></model-list-select>
                      <!-- <b-form-input :formatter="capitalizeAll" :disabled="item.mainffId!=''?true:false" v-model="item.ffType"></b-form-input> -->
                    </td>
                    <td>
                      <model-list-select
                        :isDisabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        :list="containerMasterData"
                        v-model="item.containerType"
                        option-value="containerType"
                        option-text="containerType"
                        placeholder="Select Type"
                      ></model-list-select>
                    </td>

                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="getFinalAmount(index)"
                        :disabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        type="number"
                        v-model="item.quantity"
                      ></b-form-input>
                    </td>
                    <!-- <td>
                     
                    </td>-->
                    <td>
                      <!-- :disabled="item.mainffId!=''?true:false" -->
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="getFinalAmount(index)"
                        type="number"
                        disabled
                        v-model="item.ffSellingRate"
                      ></b-form-input>
                    </td>
                    <td>
                      <!-- :disabled="item.ffSellingRate==''?true:false" -->
                      <b-form-input
                        :formatter="capitalizeAll"
                        :disabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        @input="getFinalAmount(index)"
                        type="number"
                        v-model="item.sellingRateFinal"
                      ></b-form-input>
                    </td>
                    <td>
                      <!-- :disabled="item.ffSellingRate==''?true:false" -->
                      <model-list-select
                        :isDisabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        :list="currencyList"
                        v-model="item.currency"
                        option-value="currencyV"
                        option-text="currencyT"
                        placeholder="Select"
                      ></model-list-select>
                      <b-form-input
                        :formatter="capitalizeAll"
                        class="mt-2"
                        :disabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        @input="getFinalAmount(index)"
                        type="number"
                        v-model="item.exchRate"
                      ></b-form-input>
                      <model-list-select
                        class="mt-2"
                        :isDisabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        :list="unitList"
                        v-model="item.unit"
                        option-value="unitId"
                        option-text="unitName"
                        placeholder="Select"
                      ></model-list-select>
                    </td>

                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        :disabled="
                          chnageApprovalStatus == '1' && !item.mainffId ? true : false
                        "
                        v-model="item.invAmount"
                      ></b-form-input>
                    </td>
                    <!-- <td>
                     
                    </td>-->

                    <td>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        v-model="item.remark"
                      ></b-form-textarea>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label>Job No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="clientName"
                  name="clientName"
                  v-model="ffInvoiceModal.chnageApprovalStatus"
                ></b-form-input>
              </md-layout>
            </md-layout>
              </md-layout>-->
              <!-- /.box-body -->

              <b-row v-if="!MBLFlag">
                 <b-col md="4">
                  <label>Shipment Type</label>
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="MBLData.bl_shipment_type"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeTxt"
                    placeholder="Select Shipment Type"
                  ></model-list-select>
                  <span class="error" v-if="!MBLData.bl_shipment_type">{{
                    errorMBLList.bl_shipment_type
                  }}</span>
                </b-col>
                <b-col md="4">
                  <label>B/L Type</label>
                  <model-list-select
                    :isDisabled="true"
                    :list="blTypeList"
                    v-model="MBLData.blType"
                    option-value="blTypeVal"
                    option-text="blTypeTxt"
                    placeholder="Select B/L Type"
                  ></model-list-select>
                  <span class="error" v-if="!MBLData.blType">{{
                    errorMBLList.blType
                  }}</span>
                </b-col>
                <b-col md="4">
                  <label>Liner Freght Terms</label>
                  <model-list-select
                    :list="frghtTermsLinerListName"
                    v-model="MBLData.frghtTermsLiner"
                    option-value="frghtTermsLinerVal"
                    option-text="frghtTermsLinerTxt"
                    placeholder="Select Freght Terms"
                  ></model-list-select>
                  <span class="error" v-if="!MBLData.frghtTermsLiner">{{
                    errorMBLList.frghtTermsLiner
                  }}</span>
                </b-col>
                <b-col md="4">
                  <label>MBL Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="linerBLNumber"
                    name="linerBLNumber"
                    v-model="MBLData.linerBLNumber"
                  ></b-form-input>
                  <span class="error" v-if="!MBLData.linerBLNumber">{{
                    errorMBLList.linerBLNumber
                  }}</span>
                </b-col>
                <b-col md="12" v-if="MBLData.bl_shipment_type !== 'NOMINATION' && MBLData.blType !== 'HouseBL'">
                  <label>MBL Upload</label>

                  <multi-file-uploader
                    :style="`height: 79px;    background: darkgray;    width: 300px;`"
                    v-if="ffInvoiceModal.allModuleId"
                    :documentName="'Liner BL'"
                    :otherDocName="'Liner BL'"
                    :folderName="'Doc Library'"
                    :accept="'*'"
                    :assign_no="ffInvoiceModal.jobNo"
                    :multiple="false"
                    v-model="singleUpload"
                    :state="Boolean(singleUpload)"
                    :fileAllModuleId="ffInvoiceModal.allModuleId"
                  ></multi-file-uploader>
                  <span v-if="ffInvoiceModal.allModuleId"
                    >Choose a file or drop it above...</span
                  >
                  <span class="error">{{ errorMBLList.linerBLupload }}</span>
                </b-col>

                <b-col class="ml-2" md="4">
                  <b-button
                    class="smbutnWidth mt-3"
                    :disabled="MBLFlag == true ? true : false"
                    variant="primary"
                    @click="saveMBL"
                    id="addButtonLoader"
                    >Save MBL</b-button
                  >
                </b-col>
              </b-row>
              <b-row v-else>
                <table class="table table-sm table-bordered" v-if="MBLList.length > 0">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col">SN.</th>
                       <th scope="col">Shipment Type</th>
                      <th scope="col">BL Type</th>
                      <th scope="col">Liner Freght Terms</th>
                      <th scope="col">MBL Number</th>
                      <th scope="col">PDF</th>
                    </tr>
                    <tr v-for="(itm, idx) in MBLList" :key="idx">
                      <th scope="row">{{ idx + 1 }}</th>
                      <td>
                        <span v-if="itm.bl_shipment_type">{{ itm.bl_shipment_type }}</span>
                      </td>
                      <td>
                        <span v-if="itm.blType">{{ itm.blType }}</span>
                      </td>
                      <td>
                        <span v-if="itm.blType">{{ itm.frghtTermsLiner }}</span>
                      </td>
                      <td>
                        <span v-if="itm.blType">{{ itm.linerBLNumber }}</span>
                      </td>
                      <td>
                        <span class="error" v-if="itm.linerBLupload"
                          ><b-button
                            variant="outline-warning"
                            size="sm"
                            style="font-size: 0.675rem"
                            class="text-danger"
                            @click="PrintNote(itm.linerBLupload, ffInvoiceModal.jobNo)"
                            >PDF</b-button
                          ></span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-row>

              <ExpenseTableComponent
                v-if="ffInvoiceModal.allModuleId && is_noe_validation"
                :show-debug="false"
                :initial-expenses="initialExpenses"
                :enable-validation="true"
                ref="expenseTableComponent"
                @expenses-saved="handleExpensesSaved"
                @expense-validation="handleExpenseValidation"
                :allModuleId="ffInvoiceModal.allModuleId"
                :jobNo="ffInvoiceModal.jobNo"
                :moduleType="'FF Con'"
                :transportType="'Export'"
                :branchId="$sessionsStorage.get('branch_baseLocation')"
                :invoiceStatus="ffInvoiceModal.invoiceStatus"
              />
              <OldExpenseAdditionalTask
                v-if="ffInvoiceModal.allModuleId"
                :allModuleId="ffInvoiceModal.allModuleId"
                :type="'additional-task'"
              />

              <md-layout md-gutter class="mrgtop-2per">
                <!-- v-if="validateTally==false" -->
                <md-layout md-flex="50">
                  <b-button
                    class="smbutnWidth mt-3"
                    :disabled="
                      DisableSubmit == '0' || validSubmit == false ? true : false
                    "
                    v-if="validateTally == false && this.sentForApproval != '1'"
                    variant="primary"
                    @click="submitInvoice('1')"
                    id="addButtonLoader"
                  >
                    <!-- @click="MBLFlag ? submitInvoice('1') : checkMBLDetails()" -->
                    {{
                      ffInvoiceModal.invoiceStatus == "0"
                        ? "Save & Submit To Accounts"
                        : "Save"
                    }}
                  </b-button>
                  <span
                    v-if="updateTime != 'null' && editUserName != 'null'"
                    style="
                      mmargin-top: auto;
                      margin-bottom: auto;
                      padding-top: 20px;
                      margin-left: 20px;
                    "
                  >
                    Last Updated At :
                    <span style="color: red">{{ updateTime }}</span> , By :
                    <span style="color: red">{{ editUserName }}</span>
                  </span>

                  <md-spinner
                    md-indeterminate
                    id="loader"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="15">
                  <b-button
                    :disabled="DisableSubmit == '0' ? true : false"
                    class="smbutnWidth mt-3"
                    v-if="validateTally == true && this.sentForApproval != '1'"
                    variant="dark"
                    @click="submitInvoice('2')"
                    >Send For Approval</b-button
                  >
                  <!-- @click="MBLFlag ? submitInvoice('2') : checkMBLDetails()" -->
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="mrgtop-2per">
            <md-layout md-flex="80"></md-layout>
            <md-layout md-flex="20">
            
              <md-button
                class="md-raised md-primary md-button-color"
                @click="ProceedBilling"
              >Proceed To Billing</md-button>
            </md-layout>
              </md-layout>-->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopMaxPer"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus,getJobNatureOfExpenseList } from "../../helper/collection";
import PaymentSummary from "../common/paymentSummary.vue";
import ProfitLoss from "../common/profitLoss.vue";
import AssignmentTimeline from "../common/assignmentTimeline.vue";
import CommonService from "../../services/CommonService.js";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import ExpenseTableComponent from "../common/expenseTableComponent.vue"; 
import OldExpenseAdditionalTask from "../allModuleForm/components/OldExpenseAdditionalTask.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/freightInvoiceForTally");
      this.getData();
      // this.checkMBLDetails();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.singleUpload = file;
      this.MBLData.linerBLupload = file;
    });
  },
  data() {
    return {
      selectDateFormat,
      trackingId: "",
      updateTime: "null",
      editUserName: "null",
      newContainerFlow: "",
      containerTypeDetailFactory: [],
      otherExpenseData: [],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "0",
          int: "Closed",
        },
      ],
      unitList: [],
      validateTally: false,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      isLoading: false,
      weightSum: "",
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ledgerData: [],
      containerMasterData: [],
      ffInvoiceModal: {
        shipperInvNoforTally: "",
        shipperInvDateforTally: "",
        shipperInvNo: "",
        shipperInvDate: "",
        invoiceStatus: "1",
        chnageApprovalStatus: "",
        InvTallyId: "",
        invDate: "",
        jobNo: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        mbl_release_date: "",
        BOE: "",

        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetails: [],
        multipleContainerType: [],
        multiConNo: [],
        shippingLine: "",
      },
      DisableSubmit: "",
      validSubmit: "",
      validateInvoice: true,

      sentForApproval: "",
      chnageApprovalStatus: "",
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
      MBLFlag: false,
      MBLList: [],
      docURL: URL_BASE_DOC,
      blTypeName: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },
        {
          blTypeVal: "LinerBL",
          blTypeTxt: "Liner B/L",
        },
      ],
      frghtTermsLinerListName: [
        {
          frghtTermsLinerVal: "Prepaid",
          frghtTermsLinerTxt: "Prepaid",
        },
        {
          frghtTermsLinerVal: "Collect",
          frghtTermsLinerTxt: "Collect",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "FREEHOLD",
          shipmentTypeTxt: "FREEHOLD",
        },
        {
          shipmentTypeVal: "NOMINATION",
          shipmentTypeTxt: "NOMINATION",
        },
      ],
      MBLData: {
        blType: "LinerBL",
        frghtTermsLiner: "",
        linerBLNumber: "",
        linerBLupload: "",
        bl_shipment_type: "FREEHOLD",
      },
      MBLError: [
        "Please Select BL Type",
        "Please Select Liner Freght Terms",
        "Please Enter MBL No",
        "Please Upload MBL Doc",
        "Please Select Shipment Type",
      ],
      errorMBLList: {
        blType: "",
        frghtTermsLiner: "",
        linerBLNumber: "",
        linerBLupload: "",
        bl_shipment_type: "",
      },
      singleUpload: [],
      validateMBL: true,
      invSaveMBLFlag: true,


      expenseValidation: {
        isValid: true,
        messages: [],
        fieldErrors: {}
      },
      initialExpenses: [],
      is_noe_validation: false,
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    PaymentSummary,
    ProfitLoss,
    AssignmentTimeline,
    MultiFileUploader,
    BannerComponent,
    AddMessage,
    ExpenseTableComponent,
    OldExpenseAdditionalTask,
  },
  watch: {
    'MBLData.bl_shipment_type': function(newVal, oldVal) {
      if (newVal === 'NOMINATION') {
        // Clear MBL upload when shipment type changes to NOMINATION
        this.MBLData.linerBLupload = "";
        this.singleUpload = [];
        this.errorMBLList.linerBLupload = "";
      }
    },
    ffInvoiceModal: {
      handler: function (newVal, oldVal) {
        if (
          (this.ffInvoiceModal.POR == "" ||
            this.ffInvoiceModal.POD == "" ||
            this.ffInvoiceModal.LP == "" ||
            this.ffInvoiceModal.FPOD == "" ||
            this.ffInvoiceModal.vessel == "" ||
            this.ffInvoiceModal.blNo == "" ||
            this.ffInvoiceModal.mbl_release_date == "" ||
            this.ffInvoiceModal.weight == "" ||
            this.ffInvoiceModal.shippingLine == "" ||
            this.ffInvoiceModal.shipperInvNo == "" ||
            this.ffInvoiceModal.shipperInvDate == "" ||
            this.ffInvoiceModal.BOE == "") &&
          this.newContainerFlow == "0"
        ) {
          this.validSubmit = false;
        } else {
          this.validSubmit = true;
        }
      },

      deep: true,
    },
  },
  computed: {
    uploadBookingStatus() {
      return this.MBLData.linerBLupload != ""
        ? this.MBLData.linerBLupload.split(",")
        : [];
    },
    blTypeList() {
      return this.blTypeName;
    },
  },
  methods: {
     getJobNatureOfExpenseList() {
      this.is_noe_validation = false; // Reset to false initially
      console.log("allModuleId", this.allModuleId)
      let payload = { module_id: this.ffInvoiceModal.allModuleId, jobNo: this.ffInvoiceModal.mainSalesSeries, moduleType: this.$route.query.ModuleType,  };
      getJobNatureOfExpenseList(payload, (error, result) => {
        if (error) {
          console.log("Catch on getNatureOfExpense Error: ", error);
          this.isSubmited = false;
        } else {
          console.log("NatureOfExpense result:", result);
          if (result && result.natureOfExpense) {
            this.natureOfExpense = result.natureOfExpense;
            this.is_noe_validation = result.is_noe_validation;
            // Also populate natureOfExpenseOptions for the dropdown
            // this.natureOfExpenseOptions = [...this.natureOfExpense];
          }
        }
        this.isLoading = false;
      });
    },
    ProceedBilling() {
      this.$router.push({
        path: "/allModuleForm/billing",
      });
    },
    getQuotRate() {
      let count1 = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.quantity != "") {
          let finalAmt = x.quantity * parseInt(x.sellingRateFinal);
          x.invAmount = finalAmt;
        }
      });
      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ffSellingRate)) {
            count++;
          }
        }
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // console.log(
      //   parseInt(item.sellingRateFinal) < parseInt(item.ffSellingRate)
      // );
      // if (item.sellingRateFinal < item.ffSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    getFinalAmount(ind) {
      if (!this.ffTallyInvoiceData[ind].exchRate) {
        this.ffTallyInvoiceData[ind].exchRate = 1;
      }
      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseFloat(this.ffTallyInvoiceData[ind].quantity) *
        parseFloat(this.ffTallyInvoiceData[ind].sellingRateFinal) *
        parseFloat(this.ffTallyInvoiceData[ind].exchRate);

      for (let i = 0; i < this.ffTallyInvoiceData.length; i++) {
        if (
          this.ffTallyInvoiceData[i].sellingRateFinal &&
          this.ffTallyInvoiceData[i].ffSellingRate != "Charges As Per Receipt" &&
          this.ffTallyInvoiceData[i].ffSellingRate != "" &&
          this.ffTallyInvoiceData[i].ffSellingRate != undefined &&
          this.chnageApprovalStatus != "1"
        ) {
          console.log(
            this.ffTallyInvoiceData[i].sellingRateFinal,
            this.ffTallyInvoiceData[i].ffSellingRate
          );
          if (
            parseInt(this.ffTallyInvoiceData[i].sellingRateFinal) >=
            parseInt(this.ffTallyInvoiceData[i].ffSellingRate)
          ) {
            //  count++;

            this.validateTally = false;
          } else {
            // console.log(x.ccSellingRate,"tyrt")
            this.validateTally = true;
            break;
            return false;
          }
        }
      }

      //  if (parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) < parseInt(this.ffTallyInvoiceData[ind].ffSellingRate)) {
      //   this.validateTally = true;

      // } else {
      //   this.validateTally = false;

      // }
      // this.ffTallyInvoiceData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
      //     x.invAmount = finalAmt;
      //   }
      // });
    },

    PrintNote(uploadCreditDebit, assign_job) {
      let key =
        "ASSIGNMENT_UPLOADS/" +
        assign_job.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    async checkMBLDetails() {
      if (
        this.$sessionsStorage.get("nameUser") != "Bhavneesh" &&
        this.$sessionsStorage.get("cust_username") != "Admin"
      ) {
        let payload = {
          itemCode: "checkConMBLDetails",
          blType: this.MBLData.blType,
          frghtTermsLiner: this.MBLData.frghtTermsLiner,
          linerBLNumber: this.MBLData.linerBLNumber,
          ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        };
        try {
          const response = await CommonService.getCheckBLDetails(payload);
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("data=>", data);
            // alert(data.MSG);
            if (data.MSG && data.MSG != null && data.MSG != undefined) {
              this.alert.content = data.MSG;
              this.MBLData.linerBLNumber = data.MSResult.MBL;
              this.$refs["addPop"].open();
              $("#linerBLNumber").focus();
            }
            this.MBLFlag = data.FLAG;
            this.MBLList = data.bllandingList;
          }
          this.isLoading = false;
        } catch (error) {
          console.log("Catch on All_BL_List Error: ", error);
        }
      }
    },
    validateMBLFunc() {
      let validate_new = true;
      Object.keys(this.errorMBLList).map((x, index) => {
        if (x === "linerBLupload" && (this.MBLData.bl_shipment_type === "NOMINATION" || this.MBLData.blType === "HouseBL")) {
          this.errorMBLList[x] = "";
          return;
        }
        if (this.MBLData[x] == "") {
          this.errorMBLList[x] = this.MBLError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validateMBL = false;
      } else {
        this.validateMBL = true;
      }
    },
    saveMBL() {
      this.MBLData.documentLink = this.singleUpload;
      this.MBLData.linerBLupload = this.singleUpload;
      this.MBLData.addedFromMain = 1;
      this.MBLData.allModuleId = this.ffInvoiceModal.allModuleId;
      this.MBLData.ffFclConsoExportId = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.MBLData.otherDocName = "Liner BL";
      this.MBLData.documentName = "Liner BL";
      this.MBLData.itemCode = "SAVECONMBL";
      this.MBLData.JOBSERIES = this.ffInvoiceModal.jobNo;
      this.validateMBLFunc();
      console.log("obj happy Sinngh=>", this.MBLData);
      if (this.validateMBL != false) {
        CommonService.getCheckBLDetails(this.MBLData)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("data=>", data);
              this.alert.content = data.MSG;

              this.$refs["addPop"].open();
              this.MBLFlag = data.FLAG;
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on All_BL_List Error: ", error);
          });
      }
    },
    async submitInvoice(id) {
        this.ffInvoiceModal.expenseData =[];
      this.ffInvoiceModal.totalExpenseAmount =0;
       // Get all expense data from child component
      let allExpenseData = [];
      if (this.$refs.expenseTableComponent && this.is_noe_validation) {
        // First validate expenses
        const expenseValidationResult = this.$refs.expenseTableComponent.validateExpensesForParent();
        if (!expenseValidationResult) {
          this.alert.content = "Please fix expense validation errors before submitting.";
          this.$refs["addPop"].open();
          return false;
        }
        
        // Get all expense data using simple common function
        const expenseData = this.getExpenseDataSimple();
        const expenseDataAll = this.getExpenseData();
        console.log("All Expense Data:", expenseData);
        console.log("All Expense Data All:", expenseDataAll);
        
        // Add to ffInvoiceModal
        this.ffInvoiceModal.expenseData = expenseData.all;
        this.ffInvoiceModal.totalExpenseAmount = expenseData.total;
      }
      if (this.invSaveMBLFlag) {
        let BLFlag = await this.checkMBLDetails();
        console.log("BLFlag=>", this.MBLFlag);
        // alert(this.MBLFlag);
        // return false;
        console.log("BLFlag=>", this.MBLFlag);
        // alert(this.MBLFlag);
      }
      if (
        this.MBLData.bl_shipment_type !== "NOMINATION" &&
        this.MBLData.blType !== "HouseBL" &&
        (this.ffInvoiceModal.mbl_release_date == "" ||
        this.ffInvoiceModal.mbl_release_date == null ||
          this.ffInvoiceModal.mbl_release_date == undefined)
      ) {
        this.ffInvoiceModal.mbl_release_dateError = "MBL Release Date. Fields is Required.";
        return false;
      }
      if(this.MBLData.bl_shipment_type === "NOMINATION" && !this.MBLData.linerBLNumber) {
        this.errorMBLList.linerBLNumber = "MBL No. Fields is Required.";
        return false;
      }

      // if (this.MBLFlag == true) {
      for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
        if (
          this.ffTallyInvoiceData[r].ffType == "OCEAN FREIGHT CHARGES-EXPORT" ||
          this.ffTallyInvoiceData[r].ffType == "OCEAN FREIGHT SEZ"
        ) {
               // For NOMINATION shipment type or HouseBL, only MBL number is required
          if (this.MBLData.bl_shipment_type === "NOMINATION" || this.MBLData.blType === "HouseBL") {
            if (this.MBLData.linerBLNumber) {
              this.MBLFlag = true;
            }
          } else {
            // For FREEHOLD LinerBL, both MBL number and upload are required
            if (this.MBLData.linerBLNumber && this.MBLData.linerBLupload) {
              this.MBLFlag = true;
            }
          }
          // if (this.MBLData.linerBLNumber && this.MBLData.linerBLupload) {
          //   this.MBLFlag = true;
          // }
          // alert(1);
          // alert(this.MBLFlag);
          console.log("Validation 1 True", this.MBLFlag);
          if (this.MBLFlag != true) {
            this.validateMBLFunc();
            break;
          }
        }

        if (
          this.ffTallyInvoiceData[r].ffType != "OCEAN FREIGHT CHARGES-EXPORT" ||
          this.ffTallyInvoiceData[r].ffType != "OCEAN FREIGHT SEZ"
        ) {
          if (this.MBLData.linerBLNumber) {
            this.MBLFlag = true;
          }
          // alert(2);
          // alert(this.MBLFlag);
          console.log("Validation 2 True", this.MBLFlag);
          if (this.MBLFlag != true) {
            break;
          }
        }

        if (
          !this.ffTallyInvoiceData[r].ffType ||
          !this.ffTallyInvoiceData[r].quantity ||
          !this.ffTallyInvoiceData[r].sellingRateFinal ||
          !this.ffTallyInvoiceData[r].unit ||
          !this.ffTallyInvoiceData[r].invAmount ||
          !this.ffTallyInvoiceData[r].currency ||
          !this.ffTallyInvoiceData[r].exchRate
        ) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].ffType) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].quantity) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].sellingRateFinal) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].unit) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].invAmount) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].currency) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else {
          console.log("All fields are Entered");
        }
      }
      if (
        this.MBLFlag == true ||
        (this.$sessionsStorage.get("nameUser") == "Bhavneesh" &&
          this.$sessionsStorage.get("cust_username") == "Admin")
      ) {
        if (id == "2") {
          this.ffInvoiceModal.invoiceStatus = "1";
        }
        this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;
        this.ffInvoiceModal["buttonId"] = id;
        let total = 0;

        this.ffTallyInvoiceData.map((x) => {
          let dummy = parseFloat(x.invAmount) + total;
          total = dummy;
        });

        this.ffInvoiceModal.totalAmount = total;

        this.ffInvoiceModal.BOE = "";
        this.containerTypeDetailFactory.map((x) => {
          this.ffInvoiceModal.BOE += x.SBNo + " / " + x.SBDate;
        });
        console.log("All Module Id => ", this.ffInvoiceModal.allModuleId);

        const { conFclBLNonUsId } = this.$route.params;

        let type_Size = {
          itemCode: "itemCode",
          ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
          ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
          conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
          conFclBLNonUsId: conFclBLNonUsId,
        };

        this.ffInvoiceModal.ffFclConsoExportId = this.$sessionsStorage.get(
          "editffFclConsoExportId"
        );
        this.ffInvoiceModal.ffConExecutionId = this.$sessionsStorage.get(
          "editffConExecutionId"
        );
        this.ffInvoiceModal.conFclBookingId = this.$sessionsStorage.get(
          "editconFclBookingId"
        );
        this.ffInvoiceModal.conFclBLNonUsId = conFclBLNonUsId;
        this.ffInvoiceModal.isconsolidation = 1;
        // console.log(this.ffInvoiceModal);
        // return false;
        if (this.validateInvoice != false) {
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/addInvoiceTallyFFWithCon.php`,
            data: JSON.stringify(this.ffInvoiceModal),

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };
          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                if (data.msg == "Inserted Successfully") {
                  this.alert.content = "Added Successfully";
                  this.ffInvoiceModal.InvTallyId = data.InvTallyId;
                } else {
                  this.alert.content = "Data Updated Successfully";
                }
                $("#addButtonLoader").css("display", "block");
                $("#loader").css("display", "none");
                this.$refs["addPop"].open();
                this.getData();
                this.invSaveMBLFlag = false;
                console.log("this.invSaveMBLFlag=>", this.invSaveMBLFlag);
              }
            })
            .catch((err) => {
              throw err;
            });
        }
      }
    },
    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
    addQuotationFields() {
      let tableFields = {
        ffType: "",
        containerType: "",
        quantity: "",
        ffSellingRate: "",
        sellingRateFinal: "",
        exchRate: "1",
        invAmount: "",
        currency: "",
        remark: "",
        mainffId: "1",
      };

      this.ffTallyInvoiceData.push(tableFields);
    },

    async getData() {
      this.isLoading = true;
      this.weightSum = "";
      this.ffTallyInvoiceData = [];

      const { conFclBLNonUsId } = this.$route.params;

      if (this.$route.query.InvTallyId != "") {
        this.ffInvoiceModal.InvTallyId = this.$route.query.InvTallyId;
      }

      let type_Size = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        conFclBLNonUsId: conFclBLNonUsId,
        InvTallyId: this.ffInvoiceModal.InvTallyId || this.$route.query.InvTallyId,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFFConInvoiceTall_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then(async (result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            console.log("Jio Data=>", data);
            if (data.stuffingData.length > 0) {
              // alert(data.stuffingData[0].shippingLine)
              this.ffInvoiceModal.shippingLine = data.stuffingData[0].shippingLine;
            }
            if (data.mainSalesData.length > 0) {
              this.MBLData = {
                blType: data.mainSalesData[0].blType,
                frghtTermsLiner: data.mainSalesData[0].frghtTermsMbl,
                linerBLNumber: data.mainSalesData[0].master_linerBLNumber,
                linerBLupload: data.mainSalesData[0].linerBLupload,
                bl_shipment_type: data.mainSalesData[0].bl_shipment_type,
              };
            }
            await this.checkMBLDetails();
            // alert(this.ffInvoiceModal.shippingLine)
            // if (data.ffExecutionDetailContainer.length > 0) {
            //   this.containerTypeDetailFactory = data.ffExecutionDetailContainer;

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.containerMasterData.length > 0) {
              this.containerMasterData = data.containerMasterData;
            } else {
              this.containerMasterData = [];
            }
            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }
            // }
            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
              this.weightSum = this.containerTypeDetailFactory.reduce(
                (a, b) => +a + +b.noOfpkgUnit,
                0
              );
              this.weightSum =
                this.weightSum + " " + this.containerTypeDetailFactory[0].noOfpkgUnit;

              this.containerTypeDetailFactory = this.containerTypeDetailFactory.filter(
                (item) => {
                  if (item.clientName == this.$route.query.clientName) {
                    return item;
                  }
                }
              );
            }
            this.newContainerFlow = data.newContainerFlow;
            let TParti = [];
            let TCon = [];
            let TSelO = [];
            let TSF = [];
            let TINV = [];
            let TCUR = [];
            let TRE = [];
            let QUN = [];
            let CON_NO = [];
            let EXRT = [];
            let CONTYPE = [];
            let UN = [];
            console.log("Test 1 => ", data.ffInvSummaryData);
            if (data.tallyTableData && data.tallyTableData.length > 0) {
              console.log("1");
              // alert("1");
              this.DisableSubmit = data.tallyTableData[0].invoiceStatus;
              this.sentForApproval = data.tallyTableData[0].sentForApproval;
              this.chnageApprovalStatus = data.tallyTableData[0].chnageApprovalStatus;
              Object.keys(data.tallyTableData[0]).map((x) => {
                if (x == "particulars") {
                  if (data.tallyTableData[0][x] != null) {
                    TParti = data.tallyTableData[0][x].split(",");
                  } else {
                    TParti = [];
                  }
                } else if (x == "containerType") {
                  if (data.tallyTableData[0][x] != null) {
                    TCon = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCon = [];
                  }
                } else if (x == "quotationRate") {
                  if (data.tallyTableData[0][x] != null) {
                    TSelO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSelO = [];
                  }
                } else if (x == "sellingRateFinal") {
                  if (data.tallyTableData[0][x] != null) {
                    TSF = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSF = [];
                  }
                } else if (x == "unit") {
                  if (data.tallyTableData[0][x] != null) {
                    UN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    UN = [];
                  }
                } else if (x == "finalRateWithoutTax") {
                  if (data.tallyTableData[0][x] != null) {
                    TINV = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TINV = [];
                  }
                } else if (x == "currency") {
                  if (data.tallyTableData[0][x] != null) {
                    TCUR = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCUR = [];
                  }
                } else if (x == "remark") {
                  if (data.tallyTableData[0][x] != null) {
                    TRE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TRE = [];
                  }
                } else if (x == "quantity") {
                  if (data.tallyTableData[0][x] != null) {
                    QUN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    QUN = [];
                  }
                } else if (x == "containerDetails") {
                  if (data.tallyTableData[0][x] != null) {
                    CON_NO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CON_NO = [];
                  }
                } else if (x == "multipleContainerType") {
                  if (data.tallyTableData[0][x] != null) {
                    CONTYPE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CONTYPE = [];
                  }
                } else if (x == "exchRate") {
                  if (data.tallyTableData[0][x] != null) {
                    EXRT = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    EXRT = [];
                  }
                } else {
                  this.ffInvoiceModal[x] = data.tallyTableData[0][x] || "";
                }
              });

              if (CON_NO.length > 0) {
                this.ffInvoiceModal.containerDetails = CON_NO;
              }
              if (CONTYPE.length > 0) {
                this.ffInvoiceModal.multipleContainerType = CONTYPE;
              }

              if (TParti.length > 0) {
                console.log("TSF => ", TSF);
                TParti.map((x, index) => {
                  let obj = {
                    ffType: x,
                    containerType: TCon[index],
                    quantity: QUN[index],
                    ffSellingRate: TSelO[index],
                    sellingRateFinal: TSF[index],
                    exchRate: EXRT[index],

                    unit: UN[index],
                    invAmount: TINV[index],
                    currency: TCUR[index],
                    remark: TRE[index],
                  };

                  this.ffTallyInvoiceData.push(obj);
                });
              }

              console.log("ffTallyInvoiceData => ", this.ffTallyInvoiceData);

              if (data.users && data.users.length > 0) {
                this.editUserName = data.users[0].employeeName;
                this.updateTime = data.tallyTableData[0].updateTime;
              }
            } else {
              //  ffInvoiceModal: {
              //   shipperInvNoforTally: "",
              //   shipperInvDateforTally: "",
              //   shipperInvNo: "",
              //   shipperInvDate: "",
              //   invoiceStatus: "1",
              //   chnageApprovalStatus: "",
              //   InvTallyId: "",
              //   invDate: "",
              //   jobNo: "",
              //   ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
              //   allModuleId: "",
              //   ccTypeExImp: "",
              //   PortAdditionalCharges: "",
              //   totalAmount: "",
              //   weight: "",
              //   vessel: "",
              //   blNo: "",
              //   BOE: "",

              //   clientName: "",
              //   contact: "",
              //   adress: "",
              //   POR: "",
              //   LP: "",
              //   POD: "",
              //   FPOD: "",
              //   containerDetails: [],
              //   multipleContainerType: [],
              //   multiConNo: [],
              //   shippingLine: "",
              // },

              this.ffInvoiceModal.jobNo = data.stuffingData[0].ffExportFclConsoSeries;
              this.ffInvoiceModal.allModuleId = data.stuffingData[0].allModuleId;
              this.ffInvoiceModal.clientName = data.ffInvSummaryData[0].clientName;
              this.ffInvoiceModal.contact = data.ffInvSummaryData[0].kycContact || "";
              this.ffInvoiceModal.adress = data.ffInvSummaryData[0].corporateAddress;
              this.ffInvoiceModal.POR = data.ffInvSummaryData[0].placeReceipt;
              this.ffInvoiceModal.LP = data.ffInvSummaryData[0].portLoad;
              this.ffInvoiceModal.POD = data.ffInvSummaryData[0].portDischarge;
              this.ffInvoiceModal.FPOD = data.ffInvSummaryData[0].placeDilievery;
              this.ffInvoiceModal.blNo = data.ffInvSummaryData[0].billLading || "";
              
              this.getTrackingDetails();

              // alert(this.ffInvoiceModal.blNo );
              this.ffInvoiceModal.vessel = data.ffInvSummaryData[0].vesselVoy;
              this.ffInvoiceModal.weight = this.weightSum;

              this.ffInvoiceModal.ffExportFclId = data.ffInvSummaryData[0].ffExportFclId;
              this.ffInvoiceModal.ccTypeExImp = data.ffInvSummaryData[0].transportType;
              // this.ffInvoiceModal.shippingLine =
              //   data.ffInvSummaryData[0].shippingLine || "";

              for (let p = 0; p < this.containerTypeDetailFactory.length; p++) {
                this.ffInvoiceModal.containerDetails.push(
                  this.containerTypeDetailFactory[p].fclConcontainerNo
                );
                this.ffInvoiceModal.multipleContainerType.push(
                  this.containerTypeDetailFactory[p].containerType
                );
              }

              console.log("Container Details => ", this.containerTypeDetailFactory);

              if (data.otherExpenseData.length > 0) {
                this.otherExpenseData = data.otherExpenseData;
              }

              if (data.quotationData.length > 0) {
                this.ffTallyInvoiceData = data.quotationData;
              } else {
                this.ffTallyInvoiceData = [];
              }

              // this.ffInvoiceModal.shippingLine =
              //   data.ffInvSummaryData[0].shippingLine || "";
              // this.ffInvoiceModal.POD = data.ffInvSummaryData[0].portDischarge;
              // this.ffInvoiceModal.POR = data.ffInvSummaryData[0].placeReceipt;
              // this.ffInvoiceModal.FPOD = data.ffInvSummaryData[0].placeDilievery;
              // this.ffInvoiceModal.LP = data.ffInvSummaryData[0].portLoad;
              // this.ffInvoiceModal.clientName =
              //   data.ffInvSummaryData[0].clientName;
              // this.ffInvoiceModal.contact = data.ffInvSummaryData[0].kycContact || "";
              // this.ffInvoiceModal.adress =
              //   data.ffInvSummaryData[0].corporateAddress;

              // this.ffInvoiceModal.weight=this.weightSum
              if (data.SBVoyageBlData.length > 0) {
                this.ffInvoiceModal.shipperInvNo = data.SBVoyageBlData[0].shipInv;
                this.ffInvoiceModal.shipperInvDate = data.SBVoyageBlData[0].shipInvDate;

                this.ffInvoiceModal.BOE =
                  data.SBVoyageBlData[0].sbNo + " / " + data.SBVoyageBlData[0].sbDate;
                if (data.ffInvSummaryData[0].vesselVoy) {
                  this.ffInvoiceModal.vessel = data.ffInvSummaryData[0].vesselVoy;
                }
                if (data.SBVoyageBlData[0].billLading) {
                  this.ffInvoiceModal.blNo =
                    data.SBVoyageBlData[0].billLading + data.SBVoyageBlData[0].fclBlId;
                }
                // this.ffInvoiceModal.shipperInvNo=data.SBVoyageBlData[0].shipInvDate;
              }

              // this.ffInvoiceModal.allModuleId =
              //   data.ffInvSummaryData[0].allModuleId;
            }
            if (data.stuffingData.length > 0) {
              this.ffInvoiceModal.shippingLine = data.stuffingData[0].shippingLine;
              this.ffInvoiceModal.mbl_release_date = data.ffInvSummaryData[0].mbl_release_date || "";
            }
              this.ffInvoiceModal.mbl_release_date=data.mainSalesData[0].mbl_release_date;
            
            // this.ffInvoiceModal.shippingLine = data.stuffingData[0].shippingLine;
            // alert(this.ffInvoiceModal.shippingLine)
            this.isLoading = false;
            this.getJobNatureOfExpenseList();
          }
        })
        .catch((error) => {});
    },

    getDataNew() {
      this.isLoading = true;
      this.weightSum = "";
      this.ffTallyInvoiceData = [];

      const { conFclBLNonUsId } = this.$route.params;

      let type_Size = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        conFclBLNonUsId: conFclBLNonUsId,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFFConInvoiceTall_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            alert("ps")
            // if (data.ffExecutionDetailContainer.length > 0) {
            //   this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
            // }
            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
              this.weightSum = this.containerTypeDetailFactory.reduce(
                (a, b) => +a + +b.noOfpkgUnit,
                0
              );
              this.weightSum =
                this.weightSum + " " + this.containerTypeDetailFactory[0].noOfpkgUnit;
            }
            this.newContainerFlow = data.newContainerFlow;
            let TParti = [];
            let TCon = [];
            let TSelO = [];
            let TSF = [];
            let TINV = [];
            let TCUR = [];
            let TRE = [];
            let QUN = [];
            let CON_NO = [];
            let EXRT = [];
            let CONTYPE = [];
            let UN = [];
            console.log("Test 1 => ", data.ffInvSummaryData);
            if (data.tallyTableData && data.tallyTableData.length > 0) {
              console.log("1");
              this.DisableSubmit = data.tallyTableData[0].invoiceStatus;
              this.sentForApproval = data.tallyTableData[0].sentForApproval;
              this.chnageApprovalStatus = data.tallyTableData[0].chnageApprovalStatus;
              Object.keys(data.tallyTableData[0]).map((x) => {
                if (x == "particulars") {
                  if (data.tallyTableData[0][x] != null) {
                    TParti = data.tallyTableData[0][x].split(",");
                  } else {
                    TParti = [];
                  }
                } else if (x == "containerType") {
                  if (data.tallyTableData[0][x] != null) {
                    TCon = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCon = [];
                  }
                } else if (x == "quotationRate") {
                  if (data.tallyTableData[0][x] != null) {
                    TSelO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSelO = [];
                  }
                } else if (x == "sellingRateFinal") {
                  if (data.tallyTableData[0][x] != null) {
                    TSF = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSF = [];
                  }
                } else if (x == "unit") {
                  if (data.tallyTableData[0][x] != null) {
                    UN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    UN = [];
                  }
                } else if (x == "finalRateWithoutTax") {
                  if (data.tallyTableData[0][x] != null) {
                    TINV = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TINV = [];
                  }
                } else if (x == "currency") {
                  if (data.tallyTableData[0][x] != null) {
                    TCUR = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCUR = [];
                  }
                } else if (x == "remark") {
                  if (data.tallyTableData[0][x] != null) {
                    TRE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TRE = [];
                  }
                } else if (x == "quantity") {
                  if (data.tallyTableData[0][x] != null) {
                    QUN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    QUN = [];
                  }
                } else if (x == "containerDetails") {
                  if (data.tallyTableData[0][x] != null) {
                    CON_NO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CON_NO = [];
                  }
                } else if (x == "multipleContainerType") {
                  if (data.tallyTableData[0][x] != null) {
                    CONTYPE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CONTYPE = [];
                  }
                } else if (x == "exchRate") {
                  if (data.tallyTableData[0][x] != null) {
                    EXRT = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    EXRT = [];
                  }
                } else {
                  this.ffInvoiceModal[x] = data.tallyTableData[0][x] || "";
                }
              });

              if (CON_NO.length > 0) {
                this.ffInvoiceModal.containerDetails = CON_NO;
              }
              if (CONTYPE.length > 0) {
                this.ffInvoiceModal.multipleContainerType = CONTYPE;
              }

              if (TParti.length > 0) {
                console.log(TSF);
                TParti.map((x, index) => {
                  let obj = {
                    ffType: x,
                    containerType: TCon[index],
                    quantity: QUN[index],
                    ffSellingRate: TSelO[index],
                    sellingRateFinal: TSF[index],
                    exchRate: EXRT[index],

                    unit: UN[index],
                    invAmount: TINV[index],
                    currency: TCUR[index],
                    remark: TRE[index],
                  };

                  this.ffTallyInvoiceData.push(obj);
                });
              }
            } else {
              console.log("2");
              this.ffInvSummaryData = data.ffInvSummaryData;

              console.log("Test => ", data.ffInvSummaryData);
              // this.ffInvoiceModal.jobNo = data.ffInvSummaryData[0].BLSeries
              this.ffInvoiceModal.jobNo = data.stuffingData[0].ffExportFclConsoSeries;
              this.ffInvoiceModal.allModuleId = data.stuffingData[0].allModuleId;
              console.log("All module Id => ", this.ffInvoiceModal.allModuleId);

              if (data.containerMasterData.length > 0) {
                this.containerMasterData = data.containerMasterData;
              } else {
                this.containerMasterData = [];
              }

              console.log("containerMasterData => ", data.containerMasterData);

              if (data.ledgerData.length > 0) {
                this.ledgerData = data.ledgerData;
              } else {
                this.ledgerData = [];
              }
              if (data.unitList.length > 0) {
                this.unitList = data.unitList;
              } else {
                this.unitList = [];
              }

              if (data.otherExpenseData.length > 0) {
                this.otherExpenseData = data.otherExpenseData;
              }

              this.ffInvoiceModal.shippingLine =
                data.ffInvSummaryData[0].shippingLine || "";
              this.ffInvoiceModal.POD = data.ffInvSummaryData[0].portDischarge;
              this.ffInvoiceModal.POR = data.ffInvSummaryData[0].placeReceipt;
              this.ffInvoiceModal.FPOD = data.ffInvSummaryData[0].placeDilievery;
              this.ffInvoiceModal.LP = data.ffInvSummaryData[0].portLoad;
              this.ffInvoiceModal.clientName = data.ffInvSummaryData[0].clientName;
              this.ffInvoiceModal.contact = data.ffInvSummaryData[0].kycContact || "";
              this.ffInvoiceModal.adress = data.ffInvSummaryData[0].corporateAddress;
              for (let p = 0; p < this.containerTypeDetailFactory.length; p++) {
                this.ffInvoiceModal.containerDetails.push(
                  this.containerTypeDetailFactory[p].containerNo
                );
                this.ffInvoiceModal.multipleContainerType.push(
                  this.containerTypeDetailFactory[p].containerType
                );
              }
              this.ffInvoiceModal.weight = this.weightSum;
              if (data.SBVoyageBlData.length > 0) {
                this.ffInvoiceModal.shipperInvNo = data.SBVoyageBlData[0].shipInv;
                this.ffInvoiceModal.shipperInvDate = data.SBVoyageBlData[0].shipInvDate;

                this.ffInvoiceModal.BOE =
                  data.SBVoyageBlData[0].sbNo + " / " + data.SBVoyageBlData[0].sbDate;
                if (data.ffInvSummaryData[0].vesselVoy) {
                  this.ffInvoiceModal.vessel = data.ffInvSummaryData[0].vesselVoy;
                }
                if (data.SBVoyageBlData[0].billLading) {
                  this.ffInvoiceModal.blNo =
                    data.SBVoyageBlData[0].billLading + data.SBVoyageBlData[0].fclBlId;
                }
                // this.ffInvoiceModal.shipperInvNo=data.SBVoyageBlData[0].shipInvDate;
              }

              // this.ffInvoiceModal.allModuleId =
              //   data.ffInvSummaryData[0].allModuleId;
              this.ffInvoiceModal.ffExportFclId = data.ffInvSummaryData[0].ffExportFclId;
              this.ffInvoiceModal.ccTypeExImp = data.ffInvSummaryData[0].transportType;
              if (data.quotationData.length > 0) {
                this.ffTallyInvoiceData = data.quotationData;
              } else {
                this.ffTallyInvoiceData = [];
              }
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/paymentDetail"
      // });
    },
    proceedAssignmentProforma(
      all_module_id,

      isConsolidation,
      mainSalesSeries
    ) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id,
        });
      }
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.ffInvoiceModal.allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch((error) => {});
    },

     handleExpensesSaved(expenses) {
      console.log('Expenses saved:', expenses);
      // Handle the saved expenses data
    },

    handleExpenseValidation(validationData) {
      this.expenseValidation = validationData;
      console.log('Expense validation:', validationData);
    },

    // Method to get expense data from child component
    getExpenseData() {
      if (this.$refs.expenseTableComponent) {
        return this.$refs.expenseTableComponent.getAllExpensesData();
      }
      return [];
    },

    // Simple common function to get all expense data
    getExpenseDataSimple() {
      if (!this.$refs.expenseTableComponent) {
        return { all: [], total: 0 };
      }
      
      const allExpenses = this.$refs.expenseTableComponent.getAllExpensesDataComplete();
      const total = allExpenses.reduce((sum, exp) => {
        return sum + (parseFloat(exp.amountToBePaid) || 0) + (parseFloat(exp.amountToBeBilled) || 0);
      }, 0);
      
      return { all: allExpenses, total };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// freightConInvoiceForTally.vue?633c3f6c